import React, { useEffect, useState } from 'react';

import lodash from 'lodash';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';

import { Box, Card, Stack, TextField } from '@mui/material';

import { usePersonalInfo } from './hooks/usePersonalInfo';
import Spin from 'components/Spin';
import Text from 'components/Text';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';

import 'react-phone-input-2/lib/style.css';

const PersonalInfoForm: React.FC = () => {
  const theme = useThemeContext();
  const { control, handleSubmit, errors, updatePersonalInfo, watch, loading } = usePersonalInfo();

  const formValues = watch();
  const [isEdited, setIsEdited] = useState(false);

  const debouncedSubmit = lodash.debounce(values => {
    if (isEdited) {
      handleSubmit(() => updatePersonalInfo(values))();
      setIsEdited(false);
    }
  }, 3000);

  useEffect(() => {
    if (isEdited) {
      debouncedSubmit(formValues);
    }

    return () => {
      debouncedSubmit.cancel();
    };
  }, [formValues, isEdited]);

  const handleFieldChange = () => {
    setIsEdited(true);
  };

  if (loading) {
    return <Spin centerHorizontally centerVertically />;
  }

  return (
    <Box>
      <Stack spacing={1}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="stretch">
          <Card sx={{ flex: 1 }}>
            <Text color="textPrimary" bold>
              Nome
            </Text>
            <Controller
              name="firstName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  required
                  fullWidth
                  error={!!errors.firstName}
                  helperText={errors.firstName?.message}
                  onChange={e => {
                    field.onChange(e);
                    handleFieldChange();
                  }}
                />
              )}
            />
          </Card>
          <Card sx={{ flex: 1 }}>
            <Text color="textPrimary" bold>
              Sobrenome
            </Text>
            <Controller
              name="lastName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  required
                  fullWidth
                  error={!!errors.lastName}
                  helperText={errors.lastName?.message}
                  onChange={e => {
                    field.onChange(e);
                    handleFieldChange();
                  }}
                />
              )}
            />
          </Card>
          <Card sx={{ flex: 1 }}>
            <Text color="textPrimary" bold>
              Whatsapp
            </Text>
            <Controller
              name="whatsapp"
              control={control}
              render={({ field }) => (
                <PhoneInput
                  {...field}
                  country={'br'}
                  specialLabel=""
                  placeholder="Telefone"
                  containerStyle={{ width: '100%' }}
                  buttonStyle={{
                    backgroundColor: 'transparent',
                    border: `1px solid ${errors.whatsapp ? theme.error : theme.text.primary}`,
                  }}
                  dropdownStyle={{ backgroundColor: theme.background.secondary }}
                  inputStyle={{
                    width: '100%',
                    height: '4.1rem',
                    backgroundColor: 'transparent',
                    border: `1px solid ${errors.whatsapp ? theme.error : theme.text.primary}`,
                    color: theme.text.primary,
                  }}
                />
              )}
              disabled
            />
          </Card>
        </Stack>
        <Box>
          <Card sx={{ flex: 1, paddingTop: 1, marginTop: 1 }}>
            <Text color="textPrimary" bold>
              Seu melhor email
            </Text>
            <Controller
              name="email"
              control={control}
              disabled
              render={({ field }) => <TextField {...field} disabled variant="outlined" fullWidth />}
            />
          </Card>
        </Box>
      </Stack>
    </Box>
  );
};

export default PersonalInfoForm;
